import React from 'react';
import {
  Typography,
  Tooltip,
} from '@material-ui/core';

export default function MatchTooltip({ guest, match, children }) {
  return (
    <Tooltip
      title={(
        <>
          <Typography component="p" variant="body2">
            {`Guest Input: ${guest}`}
          </Typography>
          <Typography component="p" variant="body2">
            {`What We Found: ${match}`}
          </Typography>
        </>
        )}
      disableFocusListener={!match}
      disableHoverListener={!match}
      disableTouchListener={!match}
      placement="right-start"
      interactive
    >
      <div>{children}</div>
    </Tooltip>
  );
}
